import { render, staticRenderFns } from "./ChangeTaskDueDate.vue?vue&type=template&id=f0f49ba2&scoped=true&"
import script from "./ChangeTaskDueDate.vue?vue&type=script&lang=js&"
export * from "./ChangeTaskDueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f49ba2",
  null
  
)

export default component.exports